import { oc } from '@orpc/contract';
import { productBindingSchema, updateProductBindingInputSchema } from '../schemas/board.schemas.js';
export const updateProductBindingContract = oc
    .route({
    method: 'PUT',
    path: '/board/product-bindings/{code}/{metric}',
    tags: ['Board'],
    summary: 'Bind a product metric to a Number KPI (or unbind with kpiId null); 400 naming expected vs actual unit on a mismatch (ADMIN, PM)',
})
    .input(updateProductBindingInputSchema)
    .output(productBindingSchema);
//# sourceMappingURL=update-product-binding.contract.js.map